import React, { useEffect, useState } from "react";
import "./layout.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { get_branch_list } from "../redux/branchlistSlice";
import store from "../redux/store";
import { useSelector } from "react-redux";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import {
  AiFillDashboard,
  AiOutlineMenuFold,
  AiOutlineMenuUnfold,
} from "react-icons/ai";
import { FiLogOut, FiMenu } from "react-icons/fi";
import { GiGasStove } from "react-icons/gi";
import { TbReport } from "react-icons/tb";
import { FaIceCream, FaTemperatureHigh } from "react-icons/fa";
import { get_dashboard_data } from "../redux/dashboardSlice";
import { fullSliderwidth, setCurrentTab } from "../redux/otherSlice";
import Linkdiv from "./Linkdiv";
import { get_temp_data } from "../redux/tempSlice";
import { get_cone_data } from "../redux/coneSlice";
import { get_gasflow_data } from "../redux/gasflowSlice";
import Modal from "./Modal";
import Button from "./Button";
import { Print } from "./Print";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const { sidebar_width, current_tab, date } = useSelector(
    (state) => state.other
  );
  const location = useLocation();
  const { branch_list, b_loading } = useSelector((state) => state.branch_list);
  const user = localStorage.getItem("user");
  const userId = JSON.parse(user);

  useEffect(() => {
    store
      .dispatch(get_branch_list(userId))
      .unwrap()
      .then((v) => {
        store.dispatch(get_dashboard_data(v.reponselist[current_tab].uuid));
        store.dispatch(
          get_temp_data({
            userid: userId,
            id: v.reponselist[current_tab].uuid,
          })
        );
        store.dispatch(
          get_cone_data({
            userid: userId,
            id: v.reponselist[current_tab].uuid,
          })
        );
        store.dispatch(
          get_gasflow_data({
            userid: userId,
            id: v.reponselist[current_tab].uuid,
          })
        );
      });
  }, []);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen1, setIsOpen1] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  return (
    <div className="dash-main-layout">
      <div className="dash-home-header">
        <div className="dash-logo-div">
          <img src="./logo.png" className="dash-logo" />
        </div>
        <div className="dash-menu-icon">
          {sidebar_width ? (
            <AiOutlineMenuFold
              size={25}
              cursor={"pointer"}
              onClick={() => {
                store.dispatch(fullSliderwidth());
              }}
            />
          ) : (
            <AiOutlineMenuUnfold
              size={25}
              cursor={"pointer"}
              onClick={() => {
                store.dispatch(fullSliderwidth());
              }}
            />
          )}
          {/* <Print /> */}
        </div>
        <div className="dash-menu-icon1">
          <FiMenu size={20} cursor={"pointer"} onClick={toggleDrawer} />
        </div>
        <div className="dash-header-content">
          {location.pathname == "/generate" ||
            branch_list.map((v, i) => (
              <div
                key={i}
                className={`${
                  current_tab == i && "dash-header-button-active"
                } dash-header-button`}
                onClick={() => {
                  store.dispatch(setCurrentTab(i));
                  store.dispatch(get_dashboard_data(v.uuid));
                  store.dispatch(
                    get_temp_data({
                      userid: userId,
                      id: v.uuid,
                      start: date.start,
                      end: date.end,
                    })
                  );
                  store.dispatch(
                    get_cone_data({
                      userid: userId,
                      id: v.uuid,
                      start: date.start,
                      end: date.end,
                    })
                  );
                  store.dispatch(
                    get_gasflow_data({
                      userid: userId,
                      id: v.uuid,
                      start: date.start,
                      end: date.end,
                    })
                  );
                }}
              >
                {v.name}
              </div>
            ))}
        </div>
      </div>
      <div className="dash-main">
        <div
          className="dash-sidebar"
          style={{
            position: "relative",
            width: sidebar_width ? "13rem" : "3rem",
            transition: "width ease 1s",
          }}
        >
          <div className="dash-sidebar-top">
            <Linkdiv
              title={"Dashboard"}
              icon={<AiFillDashboard size={20} />}
              // icon={<AiOutlineDashboard size={20} />}
              to={"/"}
              className={location.pathname == "/" && "dash-link-active"}
            />
            <Linkdiv
              title={"Temperature"}
              icon={<FaTemperatureHigh size={20} />}
              to={"/temperature"}
              className={
                location.pathname == "/temperature" && "dash-link-active"
              }
            />
            <Linkdiv
              title={"Cones Count"}
              icon={<FaIceCream size={20} />}
              to={"/cones-count"}
              className={
                location.pathname == "/cones-count" && "dash-link-active"
              }
            />
            <Linkdiv
              title={"Gas Flow"}
              icon={<GiGasStove size={20} />}
              to={"/gas-flow"}
              className={location.pathname == "/gas-flow" && "dash-link-active"}
            />
            <Linkdiv
              title={"Reports"}
              icon={<TbReport size={20} />}
              to={"/generate"}
              className={location.pathname == "/generate" && "dash-link-active"}
            />
          </div>
          <div style={{ display: "flex", flex: 1, height: "100%" }} />
          <div className="dash-sidebar-top">
            <div className="dash-link" onClick={() => setIsOpen1(true)}>
              <FiLogOut size={20} />
              Log Out
            </div>
          </div>
        </div>
        <div className="dash-home-outlet">
          <Outlet />
        </div>
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className=""
        style={{ width: "13rem" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div className="dash-sidebar-top">
            <Linkdiv
              onClick={() => toggleDrawer()}
              title={"Dashboard"}
              icon={<AiFillDashboard size={20} />}
              to={"/"}
              className={location.pathname == "/" && "dash-link-active"}
            />
            <Linkdiv
              title={"Temperature"}
              icon={<FaTemperatureHigh size={20} />}
              to={"/temperature"}
              className={
                location.pathname == "/temperature" && "dash-link-active"
              }
              onClick={() => toggleDrawer()}
            />
            <Linkdiv
              title={"Cones Count"}
              icon={<FaIceCream size={20} />}
              to={"/cones-count"}
              className={
                location.pathname == "/cones-count" && "dash-link-active"
              }
              onClick={() => toggleDrawer()}
            />
            <Linkdiv
              title={"Gas Flow"}
              icon={<GiGasStove size={20} />}
              to={"/gas-flow"}
              className={location.pathname == "/gas-flow" && "dash-link-active"}
              onClick={() => toggleDrawer()}
            />
            <Linkdiv
              title={"Reports"}
              icon={<TbReport size={20} />}
              to={"/generate"}
              className={location.pathname == "/generate" && "dash-link-active"}
              onClick={() => toggleDrawer()}
            />
          </div>
          <div style={{ display: "flex", flex: 1, height: "100%" }} />
          <div className="dash-sidebar-top">
            <div
              className="dash-link"
              onClick={() => {
                setIsOpen1(true);
                toggleDrawer();
              }}
            >
              <FiLogOut size={20} />
              Log Out
            </div>
          </div>
        </div>
      </Drawer>
      {isOpen1 && (
        <Modal
          setIsOpen={setIsOpen1}
          data={
            <div>
              <div className="title mb20 tac">Log Out</div>
              <div className="title mb20">
                Are you sure you want to log out?
              </div>
              <div className="df alc jcsb ">
                <Button
                  title={"Log Out"}
                  onClick={() => {
                    localStorage.removeItem("user");
                    navigate("/");
                    window.location.reload();
                  }}
                />
                <Button title={"Cancel"} onClick={() => setIsOpen1(false)} />
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};

export default DashboardLayout;
